import { uploadImageToS3 } from './s3Service';

export async function uploadImageToS3Optimized(
  file: File,
  folder: string,
  _options?: {
    width?: number;
    height?: number;
    quality?: number;
    format?: 'jpeg' | 'png' | 'webp';
  }
): Promise<string> {
  // Server tarafı sharp ile optimize ediyor, client-side optimizasyona gerek yok
  return await uploadImageToS3(file, folder);
}

export async function uploadImageToS3AsWebP(file: File, folder: string): Promise<string> {
  // Server tarafı otomatik WebP'ye çeviriyor
  return await uploadImageToS3(file, folder);
}
